import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getDataProps from 'commons/getDataProps';
import CtaWrapper from './CtaWrapper';
import CtaContent from './CtaContent';
const Cta = React.forwardRef((t0, ref) => {
  const $ = _c(162);
  let T0;
  let children;
  let color;
  let hasArrow;
  let hasBackArrow;
  let hasUnderline;
  let isHovered;
  let isLoading;
  let style;
  let styling;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let textClassName;
  if ($[0] !== ref || $[1] !== t0) {
    const {
      "aria-describedby": ariaDescribedBy,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-pressed": ariaPressed,
      as,
      block: t27,
      children: t28,
      className: t29,
      color: t30,
      "data-xc": dataXc,
      disabled: t31,
      download,
      hasArrow: t32,
      noHorizontalPadding: t33,
      hasBackArrow: t34,
      hasUnderline: t35,
      id,
      isBold: t36,
      isHovered: t37,
      isLoading: t38,
      itemProp: t39,
      itemType: t40,
      noLinkPadding: t41,
      onClick,
      onMouseDown,
      onMouseLeave,
      onMouseEnter,
      onMouseUp,
      onTouchEnd,
      onTouchStart,
      size: t42,
      spacing: t43,
      style: t44,
      styling: t45,
      tabIndex,
      target,
      textClassName: t46,
      to,
      type,
      ...otherProps
    } = t0;
    children = t28;
    isHovered = t37;
    textClassName = t46;
    const block = t27 === undefined ? false : t27;
    const className = t29 === undefined ? "" : t29;
    color = t30 === undefined ? "black" : t30;
    const disabled = t31 === undefined ? false : t31;
    hasArrow = t32 === undefined ? true : t32;
    const noHorizontalPadding = t33 === undefined ? false : t33;
    hasBackArrow = t34 === undefined ? false : t34;
    hasUnderline = t35 === undefined ? false : t35;
    const isBold = t36 === undefined ? true : t36;
    isLoading = t38 === undefined ? false : t38;
    const itemProp = t39 === undefined ? null : t39;
    const itemType = t40 === undefined ? null : t40;
    const noLinkPadding = t41 === undefined ? false : t41;
    const size = t42 === undefined ? "base" : t42;
    const spacing = t43 === undefined ? "md" : t43;
    let t47;
    if ($[39] !== t44) {
      t47 = t44 === undefined ? {} : t44;
      $[39] = t44;
      $[40] = t47;
    } else {
      t47 = $[40];
    }
    style = t47;
    styling = t45 === undefined ? "link" : t45;
    T0 = CtaWrapper;
    t1 = ariaDescribedBy;
    t2 = ariaLabel;
    t3 = ariaLabelledBy;
    t4 = ariaPressed;
    t5 = as;
    const t48 = `group/cta font-sans relative [&_svg]:!mt-0 [&_svg]:!mr-2 [&_svg]:!mb-0 [&_svg]:!ml-0 hover:cursor-pointer no-underline select-none text-center ${className}`;
    const t49 = styling === "simple-img-button" || styling === "link" && noLinkPadding || styling === "link" && !hasArrow && !hasBackArrow;
    let t50;
    if ($[41] !== block || $[42] !== styling) {
      t50 = ["simple-img-button", "solid-button"].includes(styling) && !block;
      $[41] = block;
      $[42] = styling;
      $[43] = t50;
    } else {
      t50 = $[43];
    }
    let t51;
    if ($[44] !== block || $[45] !== styling) {
      t51 = ["outline-button", "rainbow-button"].includes(styling) && !block;
      $[44] = block;
      $[45] = styling;
      $[46] = t51;
    } else {
      t51 = $[46];
    }
    let t52;
    if ($[47] !== spacing || $[48] !== styling) {
      t52 = ["outline-button", "rainbow-button", "simple-img-button", "solid-button"].includes(styling) && ["sm", "md"].includes(spacing);
      $[47] = spacing;
      $[48] = styling;
      $[49] = t52;
    } else {
      t52 = $[49];
    }
    let t53;
    if ($[50] !== spacing || $[51] !== styling) {
      t53 = ["outline-button", "solid-button"].includes(styling) && spacing === "xs";
      $[50] = spacing;
      $[51] = styling;
      $[52] = t53;
    } else {
      t53 = $[52];
    }
    let t54;
    if ($[53] !== spacing || $[54] !== styling) {
      t54 = ["outline-button", "solid-button"].includes(styling) && spacing === "sm";
      $[53] = spacing;
      $[54] = styling;
      $[55] = t54;
    } else {
      t54 = $[55];
    }
    let t55;
    if ($[56] !== spacing || $[57] !== styling) {
      t55 = ["outline-button", "solid-button"].includes(styling) && spacing === "md";
      $[56] = spacing;
      $[57] = styling;
      $[58] = t55;
    } else {
      t55 = $[58];
    }
    const t56 = styling === "link-underline" && (spacing === "xs" || spacing === "sm");
    const t57 = styling === "link-underline" && spacing === "md";
    const t58 = styling === "simple-img-button";
    const t59 = styling === "solid-button";
    const t60 = styling === "solid-button" && color === "black";
    const t61 = styling === "solid-button" && color === "brand";
    const t62 = styling === "solid-button" && color === "brand-light";
    const t63 = styling === "solid-button" && color === "hotpink";
    const t64 = styling === "solid-button" && color === "white";
    const t65 = styling === "outline-button";
    const t66 = styling === "outline-button" && color === "black";
    const t67 = styling === "outline-button" && color === "brand";
    const t68 = styling === "outline-button" && color === "white";
    const t69 = styling === "rainbow-button";
    const t70 = styling === "rainbow-button";
    const t71 = styling === "rainbow-button";
    const t72 = styling === "rainbow-button";
    const t73 = styling === "rainbow-button";
    const t74 = styling === "rainbow-button" && isHovered;
    const t75 = styling === "link" || styling === "link-underline";
    const t76 = (styling === "link" || styling === "link-underline") && color === "brand" || (styling === "link" || styling === "link-underline") && isHovered && (hasBackArrow || color === "black");
    const t77 = (styling === "link" || styling === "link-underline") && color === "red";
    const t78 = (styling === "link" || styling === "link-underline") && color === "black";
    const t79 = (styling === "link" || styling === "link-underline") && color === "white";
    const t80 = (styling === "link" || styling === "link-underline") && hasBackArrow;
    let t81;
    if ($[59] !== color || $[60] !== hasArrow || $[61] !== styling) {
      t81 = (styling === "link" || styling === "link-underline") && hasArrow && ["brand", "brand-light"].includes(color);
      $[59] = color;
      $[60] = hasArrow;
      $[61] = styling;
      $[62] = t81;
    } else {
      t81 = $[62];
    }
    const t82 = (styling === "link" || styling === "link-underline") && hasArrow && color === "white";
    const t83 = styling === "link-underline";
    let t84;
    if ($[63] !== color || $[64] !== isHovered || $[65] !== styling) {
      t84 = (styling === "link" || styling === "link-underline") && isHovered || styling === "outline-button" && isHovered && !["black", "brand", "white"].includes(color);
      $[63] = color;
      $[64] = isHovered;
      $[65] = styling;
      $[66] = t84;
    } else {
      t84 = $[66];
    }
    const t85 = styling === "solid-button" && isHovered && color === "white";
    const t86 = styling === "outline-button" && isHovered && color === "black";
    const t87 = styling === "outline-button" && isHovered && color === "brand";
    const t88 = styling === "outline-button" && isHovered && color === "white";
    const t89 = size === "xs";
    const t90 = size === "sm";
    const t91 = size === "base";
    const t92 = size === "lg";
    const t93 = size === "xl";
    const t94 = size === "2xl";
    const t95 = size === "3xl";
    const t96 = size === "4xl";
    const t97 = styling === "link" && (hasArrow || hasBackArrow);
    if ($[67] !== block || $[68] !== isBold || $[69] !== isHovered || $[70] !== noHorizontalPadding || $[71] !== t48 || $[72] !== t49 || $[73] !== t50 || $[74] !== t51 || $[75] !== t52 || $[76] !== t53 || $[77] !== t54 || $[78] !== t55 || $[79] !== t56 || $[80] !== t57 || $[81] !== t58 || $[82] !== t59 || $[83] !== t60 || $[84] !== t61 || $[85] !== t62 || $[86] !== t63 || $[87] !== t64 || $[88] !== t65 || $[89] !== t66 || $[90] !== t67 || $[91] !== t68 || $[92] !== t69 || $[93] !== t70 || $[94] !== t71 || $[95] !== t72 || $[96] !== t73 || $[97] !== t74 || $[98] !== t75 || $[99] !== t76 || $[100] !== t77 || $[101] !== t78 || $[102] !== t79 || $[103] !== t80 || $[104] !== t81 || $[105] !== t82 || $[106] !== t83 || $[107] !== t84 || $[108] !== t85 || $[109] !== t86 || $[110] !== t87 || $[111] !== t88 || $[112] !== t89 || $[113] !== t90 || $[114] !== t91 || $[115] !== t92 || $[116] !== t93 || $[117] !== t94 || $[118] !== t95 || $[119] !== t96 || $[120] !== t97) {
      t6 = classNames(t48, {
        "p-0": t49,
        "inline-block": t50,
        "inline-flex": t51,
        "w-full flex justify-center items-center": block,
        "min-w-[140px]": t52,
        "py-2 px-1 md:px-4": t53,
        "py-2 px-2 md:px-8": t54,
        "py-[0.8rem] px-2 md:px-8": t55,
        "py-2 px-0": t56,
        "py-[0.8rem] px-0": t57,
        "border-0 duration-200 ease-out w-full": t58,
        "border-2 border-solid border-transparent rounded-sm transition-[background,border-color,color] duration-200 ease-out focus:shadow-[0_0_0_4px_#fff,0_0_0_5px_#717171,0_0_0_6px_hsla(0,0%,100%,.5)] focus:outline-0 focus:[transition:box-shadow_.2s_ease_0s] disabled:bg-gray-light6 disabled:text-gray disabled:cursor-not-allowed": t59,
        "bg-gray-dark text-white active:bg-black focus:bg-black hover:bg-black": t60,
        "bg-brand text-white active:bg-[#0d6370] focus:bg-[#0d6370] hover:bg-[#0d6370]": t61,
        "bg-brand-lightest text-brand-dark [transition:background-color_.15s_ease] active:bg-[#afd4da] hover:bg-brand-lighter": t62,
        "bg-[#de1c85] text-white active:bg-[#b2166a] focus:bg-[#b2166a] hover:bg-[#b2166a]": t63,
        "bg-white text-gray-dark active:bg-white hover:bg-white": t64,
        "border-2 border-solid rounded-sm items-center bg-transparent active:bg-transparent hover:bg-transparent focus:shadow-[0_0_0_4px_#fff,0_0_0_5px_#717171,0_0_0_6px_hsla(0,0%,100%,.5)] focus:outline-0 focus:[transition:box-shadow_.2s_ease_0s] disabled:cursor-not-allowed": t65,
        "border-2 border-solid border-gray text-gray-dark focus:border-brand focus:text-brand hover:border-brand hover:text-brand": t66,
        "border-2 border-solid border-brand text-brand focus:border-brand-darker focus:text-brand-darker hover:border-brand-darker hover:text-brand-darker": t67,
        "border-2 border-solid border-white text-white focus:border-white focus:text-white focus:[outline-style:auto] focus:outline-1 focus:outline-white hover:border-white hover:text-white hover:[outline-style:auto] hover:outline-1 hover:outline-white": t68,
        "pt-[10px] px-[22px] pb-[9px]": t69,
        "border-0 bg-white [transition:all_.2s_linear] items-center justify-center relative text-gray-dark text-center rounded-[100px]": t70,
        "before:content-[''] before:block before:absolute before:rounded-[inherit] before:[transition:all_.2s_linear] before:z-0 before:w-full before:h-full before:bg-rainbow": t71,
        "after:content-[''] after:block after:absolute after:rounded-[inherit] after:[transition:all_.2s_linear] after:bg-white after:h-[calc(100%_-_4px)] after:w-[calc(100%_-_4px)] after:z-[1]": t72,
        "focus:outline-0 before:focus:shadow-[0_0_0_3px_rgba(131,192,253,.5)] before:focus:outline-0 after:focus-visible:h-[calc(100%_-_10px)] after:focus-visible:w-[calc(100%_-_10px)] hover:bg-white before:hover:[transform:scale(1.00568,1.02273)] after:hover:[transform:scale(.99419,.975)] active:bg-white": t73,
        "bg-white before:[transform:scale(1.00568,1.02273)] after:[transform:scale(.99419,.975)]": t74,
        "bg-transparent border-0 relative focus-visible:outline-offset-[3px] active:bg-transparent hover:bg-transparent": t75,
        "text-brand": t76,
        "text-red": t77,
        "text-gray-dark hover:text-brand": t78,
        "text-white": t79,
        "hover:text-brand": t80,
        "text-brand hover:text-gray-dark": t81,
        "hover:text-white": t82,
        "justify-center": t83,
        "bg-transparent": t84,
        "bg-white": t85,
        "border-brand text-brand": t86,
        "border-brand-darker text-brand-darker": t87,
        "border-white text-white outline-1 [outline-style:auto] outline-white": t88,
        "text-xs": t89,
        "text-sm": t90,
        "text-base": t91,
        "text-lg": t92,
        "text-xl": t93,
        "text-2xl": t94,
        "text-3xl": t95,
        "text-4xl": t96,
        "font-bold": isBold,
        "pt-[0.8rem] pr-[2.4rem] pb-[0.8rem] pl-[1.4rem]": t97,
        "!px-0": noHorizontalPadding,
        "cursor-pointer": isHovered
      });
      $[67] = block;
      $[68] = isBold;
      $[69] = isHovered;
      $[70] = noHorizontalPadding;
      $[71] = t48;
      $[72] = t49;
      $[73] = t50;
      $[74] = t51;
      $[75] = t52;
      $[76] = t53;
      $[77] = t54;
      $[78] = t55;
      $[79] = t56;
      $[80] = t57;
      $[81] = t58;
      $[82] = t59;
      $[83] = t60;
      $[84] = t61;
      $[85] = t62;
      $[86] = t63;
      $[87] = t64;
      $[88] = t65;
      $[89] = t66;
      $[90] = t67;
      $[91] = t68;
      $[92] = t69;
      $[93] = t70;
      $[94] = t71;
      $[95] = t72;
      $[96] = t73;
      $[97] = t74;
      $[98] = t75;
      $[99] = t76;
      $[100] = t77;
      $[101] = t78;
      $[102] = t79;
      $[103] = t80;
      $[104] = t81;
      $[105] = t82;
      $[106] = t83;
      $[107] = t84;
      $[108] = t85;
      $[109] = t86;
      $[110] = t87;
      $[111] = t88;
      $[112] = t89;
      $[113] = t90;
      $[114] = t91;
      $[115] = t92;
      $[116] = t93;
      $[117] = t94;
      $[118] = t95;
      $[119] = t96;
      $[120] = t97;
      $[121] = t6;
    } else {
      t6 = $[121];
    }
    t7 = dataXc;
    t8 = disabled;
    t9 = download;
    t10 = id;
    t11 = itemProp;
    t12 = itemType;
    t13 = onClick;
    t14 = onMouseEnter;
    t15 = onMouseDown;
    t16 = onMouseLeave;
    t17 = onMouseUp;
    t18 = onTouchEnd;
    t19 = onTouchStart;
    t20 = ref;
    t21 = style.background;
    t22 = tabIndex;
    t23 = target;
    t24 = to;
    t25 = type;
    t26 = getDataProps(otherProps);
    $[0] = ref;
    $[1] = t0;
    $[2] = T0;
    $[3] = children;
    $[4] = color;
    $[5] = hasArrow;
    $[6] = hasBackArrow;
    $[7] = hasUnderline;
    $[8] = isHovered;
    $[9] = isLoading;
    $[10] = style;
    $[11] = styling;
    $[12] = t1;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
    $[23] = t2;
    $[24] = t20;
    $[25] = t21;
    $[26] = t22;
    $[27] = t23;
    $[28] = t24;
    $[29] = t25;
    $[30] = t26;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = textClassName;
  } else {
    T0 = $[2];
    children = $[3];
    color = $[4];
    hasArrow = $[5];
    hasBackArrow = $[6];
    hasUnderline = $[7];
    isHovered = $[8];
    isLoading = $[9];
    style = $[10];
    styling = $[11];
    t1 = $[12];
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t14 = $[17];
    t15 = $[18];
    t16 = $[19];
    t17 = $[20];
    t18 = $[21];
    t19 = $[22];
    t2 = $[23];
    t20 = $[24];
    t21 = $[25];
    t22 = $[26];
    t23 = $[27];
    t24 = $[28];
    t25 = $[29];
    t26 = $[30];
    t3 = $[31];
    t4 = $[32];
    t5 = $[33];
    t6 = $[34];
    t7 = $[35];
    t8 = $[36];
    t9 = $[37];
    textClassName = $[38];
  }
  let t27;
  if ($[122] !== children || $[123] !== color || $[124] !== hasArrow || $[125] !== hasBackArrow || $[126] !== hasUnderline || $[127] !== isHovered || $[128] !== isLoading || $[129] !== style.text || $[130] !== styling || $[131] !== textClassName) {
    t27 = <CtaContent className={textClassName} color={color} hasArrow={hasArrow} hasBackArrow={hasBackArrow} hasUnderline={hasUnderline} isHovered={isHovered} isLoading={isLoading} style={style.text} styling={styling}>{children}</CtaContent>;
    $[122] = children;
    $[123] = color;
    $[124] = hasArrow;
    $[125] = hasBackArrow;
    $[126] = hasUnderline;
    $[127] = isHovered;
    $[128] = isLoading;
    $[129] = style.text;
    $[130] = styling;
    $[131] = textClassName;
    $[132] = t27;
  } else {
    t27 = $[132];
  }
  let t28;
  if ($[133] !== T0 || $[134] !== t1 || $[135] !== t10 || $[136] !== t11 || $[137] !== t12 || $[138] !== t13 || $[139] !== t14 || $[140] !== t15 || $[141] !== t16 || $[142] !== t17 || $[143] !== t18 || $[144] !== t19 || $[145] !== t2 || $[146] !== t20 || $[147] !== t21 || $[148] !== t22 || $[149] !== t23 || $[150] !== t24 || $[151] !== t25 || $[152] !== t26 || $[153] !== t27 || $[154] !== t3 || $[155] !== t4 || $[156] !== t5 || $[157] !== t6 || $[158] !== t7 || $[159] !== t8 || $[160] !== t9) {
    t28 = <T0 aria-describedby={t1} aria-label={t2} aria-labelledby={t3} aria-pressed={t4} as={t5} className={t6} data-xc={t7} disabled={t8} download={t9} id={t10} itemProp={t11} itemType={t12} onClick={t13} onMouseEnter={t14} onMouseDown={t15} onMouseLeave={t16} onMouseUp={t17} onTouchEnd={t18} onTouchStart={t19} ref={t20} style={t21} tabIndex={t22} target={t23} to={t24} type={t25} {...t26}>{t27}</T0>;
    $[133] = T0;
    $[134] = t1;
    $[135] = t10;
    $[136] = t11;
    $[137] = t12;
    $[138] = t13;
    $[139] = t14;
    $[140] = t15;
    $[141] = t16;
    $[142] = t17;
    $[143] = t18;
    $[144] = t19;
    $[145] = t2;
    $[146] = t20;
    $[147] = t21;
    $[148] = t22;
    $[149] = t23;
    $[150] = t24;
    $[151] = t25;
    $[152] = t26;
    $[153] = t27;
    $[154] = t3;
    $[155] = t4;
    $[156] = t5;
    $[157] = t6;
    $[158] = t7;
    $[159] = t8;
    $[160] = t9;
    $[161] = t28;
  } else {
    t28 = $[161];
  }
  return t28;
});
Cta.propTypes = {
  'aria-describedby': PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-pressed': PropTypes.bool,
  as: PropTypes.string,
  block: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['black', 'brand-light', 'brand', 'hotpink', 'red', 'white']),
  'data-xc': PropTypes.string,
  disabled: PropTypes.bool,
  download: PropTypes.bool,
  hasArrow: PropTypes.bool,
  hasBackArrow: PropTypes.bool,
  hasUnderline: PropTypes.bool,
  id: PropTypes.string,
  isBold: PropTypes.bool,
  isHovered: PropTypes.bool,
  isLoading: PropTypes.bool,
  itemProp: PropTypes.string,
  itemType: PropTypes.string,
  noLinkPadding: PropTypes.bool,
  noHorizontalPadding: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onTouchStart: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl']),
  spacing: PropTypes.oneOf(['xs', 'sm', 'md']),
  style: PropTypes.object,
  styling: PropTypes.oneOf(['link', 'link-underline', 'outline-button', 'rainbow-button', 'simple-img-button', 'solid-button']),
  tabIndex: PropTypes.string,
  target: PropTypes.string,
  textClassName: PropTypes.string,
  to: PropTypes.string,
  type: PropTypes.string
};
export default Cta;